import React, { useEffect, useRef, useState } from "react";
import { ChromePicker } from "react-color";

const ColorPickerInput = ({ initialColor, onChange }) => {
  const [showPicker, setShowPicker] = useState(false);
  const [selectedColor, setSelectedColor] = useState(initialColor);

  const boxRef = useRef(null);

  const handleClick = () => {
    setShowPicker(!showPicker);
  };

  const handleColorChange = (color) => {
    setSelectedColor(color.hex);
    if (onChange) {
      onChange(color.hex);
    }
  };

  const handleOutsideClick = (event) => {
    if (boxRef.current && !boxRef.current.contains(event.target)) {
      setShowPicker(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  return (
    <div ref={boxRef} className="flex items-center justify-center gap-2 border border-gray-200 rounded w-75 mb-6">
      <div
        style={{
          width: "20px",
          height: "20px",
          backgroundColor: selectedColor,
          cursor: "pointer",
          borderRadius: "5px",
        }}
        className="appearance-none border rounded w-full py-2 px-3 text-black leading-tight focus:outline-none focus:shadow-outline"
        onClick={handleClick}
      />
      {showPicker && (
        <div className="absolute z-10">
          <ChromePicker 
            color={selectedColor}
            onChange={handleColorChange}
            
          />
        </div>
      )}
      <p className="m-0 p-2">{selectedColor}</p>
    </div>
  );
};

export default ColorPickerInput;
